import React from 'react';
import image3 from '../../../../../images/modules/module-2/2.png';
import image2 from '../../../../../images/modules/module-2/3.png';
import image5 from '../../../../../images/modules/module-2/8.png';
import image4 from '../../../../../images/modules/module-2/11.png';
import image1 from '../../../../../images/modules/module-2/21.png';
import { generateRandomDate } from '../../../utils';
import { NewsCard } from '../NewsCard';
import './index.scss';

export const BottomNewsContent = () => {
    return (
        <div className='runup-bottom-news-wrapper'>
            <div className='runup-bottom-news'>
                <div className='runup-bottom-news__big'>
                    <NewsCard
                        type='big'
                        src={image1}
                        text='How to Stay Motivated When Running Gets Tough'
                        date={generateRandomDate()}
                    />
                </div>
                <div className='runup-bottom-news__right'>
                    <div className='runup-bottom-news__small runup-bottom-news__small_1'>
                        <NewsCard
                            type='revert'
                            src={image2}
                            text='Socks Matter More Than You Think: Avoiding Blisters'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-bottom-news__small runup-bottom-news__small_2'>
                        <NewsCard src={image3} text='Your Marathon Training Diet' date={generateRandomDate()} />
                    </div>
                    <div className='runup-bottom-news__small runup-bottom-news__small_3'>
                        <NewsCard
                            type='revert'
                            src={image4}
                            text='The Mental Tricks Pro Runners Use to Push Through Pain'
                            date={generateRandomDate()}
                        />
                    </div>
                    <div className='runup-bottom-news__small runup-bottom-news__small_4'>
                        <NewsCard
                            src={image5}
                            text='Why a Running Streak Might Be the Boost You Need'
                            date={generateRandomDate()}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
